// use Cookies as persistance
import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

export function persistValue(name, value){
  Vue.$cookies.set(name, value);
}

export function getPersistedVar(name){
  return Vue.$cookies.get(name);
}

export function remove(name){
  Vue.$cookies.remove(name);
}
export function removeAll(){
  Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie))
}